import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { assignPageSelectors } from "../pages/assign";
import { findAllJobs, findJobsByNenki } from "../services/jobs.service";
import { jobsActions } from "../store/jobs.store";
import { onSystemFetchAllEmployees } from "./employees.saga";

/**
 * システムが全ジョブデータを取得する
 */
export function* onSystemFetchAllJobs() {
  const nenki = yield select(assignPageSelectors.getNenki);
  const jobs = yield call(findJobsByNenki, nenki);
  yield put(jobsActions.REDUCER_SET_JOBS(jobs));
}

/**
 * ジョブSaga
 */
export function* jobsSagas() {
  yield all([
    yield takeLatest(
      jobsActions.SYSTEM_FETCH_ALL_JOBS,
      onSystemFetchAllEmployees
    )
  ]);
}
